export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "analyzing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyse du document en cours..."])}
      },
      "en": {
        "analyzing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyzing the document..."])}
      }
    }
  })
}
